import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../../../util/reactIntl';
// import { ACCOUNT_SETTINGS_PAGES } from '../../../../routing/routeConfiguration';
import {
  Avatar,
  InlineTextButton,
  LinkedLogo,
  Menu,
  MenuLabel,
  MenuContent,
  MenuItem,
  NamedLink,
} from '../../../../components';

import TopbarSearchForm from '../TopbarSearchForm/TopbarSearchForm';
import CustomLinksMenu from './CustomLinksMenu/CustomLinksMenu';

import css from './TopbarDesktop.module.css';
const TopbarDesktop = props => {
  const {
    className,
    config,
    customLinks,
    currentUser,
    currentPage,
    rootClassName,
    currentUserHasListings,
    notificationCount = 0,
    intl,
    isAuthenticated,
    onLogout,
    onSearchSubmit,
    initialSearchFormValues = {},
    showSearchForm,
  } = props;
  const [mounted, setMounted] = useState(false);

  const userType = currentUser?.attributes?.profile?.publicData?.userType || {};
  const isCustomer = userType == 'customer';

  useEffect(() => {
    setMounted(true);
  }, []);
  const SignupLink = () => {
    return (
      <NamedLink name="SignupPage" className={css.topbarLink}>
        <span className={css.topbarLinkLabel}>
          <FormattedMessage id="TopbarDesktop.signup" />
        </span>
      </NamedLink>
    );
  };

  const LoginLink = () => {
    return (
      <NamedLink name="LoginPage" className={css.topbarLink}>
        <span className={css.topbarLinkLabel}>
          <FormattedMessage id="TopbarDesktop.login" />
        </span>
      </NamedLink>
    );
  };

  const InboxLink = ({ notificationCount, currentUserHasListings }) => {
    const notificationDot = notificationCount > 0 ? <div className={css.notificationDot} /> : null;
    return (
      <NamedLink
        className={css.topbarLink}
        name="InboxPage"
        params={{ tab: currentUserHasListings ? 'sales' : 'orders' }}
      >
        <span className={css.topbarLinkLabel}>
          <FormattedMessage id="TopbarDesktop.inbox" />
          {notificationDot}
        </span>
      </NamedLink>
    );
  };

  const ProfileMenu = ({ currentPage, currentUser, onLogout }) => {
    const userType = currentUser?.attributes?.profile?.publicData?.userType || {};
    const isPractitioner = userType == 'practitioner';
    const isCustomer = userType == 'customer';
    // const currentPageClass = page => {
    //   const isAccountSettingsPage =
    //     page === 'AccountSettingsPage' && ACCOUNT_SETTINGS_PAGES.includes(currentPage);
    //   return currentPage === page || isAccountSettingsPage ? css.currentPage : null;
    // };
    const inboxTab = currentUserHasListings ? 'sales' : 'orders';

    const onViewProfile = () => {
      setTimeout(() => {
        window.location.href = `/u/${currentUser?.id?.uuid}`;
      }, 0);
    };
    return (
      <Menu>
        <MenuLabel className={css.profileMenuLabel} isOpenClassName={css.profileMenuIsOpen}>
          <Avatar className={css.avatar} user={currentUser} disableProfileLink />
        </MenuLabel>
        <MenuContent className={css.profileMenuContent}>
          <MenuItem key="ProfileSettingsPage">
            {isCustomer && (
              <>
                <NamedLink className={classNames(css.menuLink)} name="ProfileSettingsPage">
                  <span className={css.menuItemBorder} />
                  <FormattedMessage id="TopbarDesktop.profileSettingsLink" />
                </NamedLink>
              </>
            )}
          </MenuItem>

          <MenuItem key="AccountSettingsPage">
            {isCustomer && (
              <>
                <NamedLink className={classNames(css.menuLink)} name="AccountSettingsPage">
                  <span className={css.menuItemBorder} />
                  <FormattedMessage id="TopbarDesktop.LoginSecurityLink" />
                </NamedLink>
                <div
                  style={{ marginTop: '16px', borderBottom: '1px solid var(--colorGrey100)' }}
                ></div>
              </>
            )}
          </MenuItem>

          {/* <MenuItem key="AccountSettingsCustomer">
            {
              isCustomer && (
                <>
                <NamedLink
                  className={classNames(css.menuLink)}
                  name="ProfileSettingsPageTab"
                  params={{ tab: 'account' }}
                >
                  <span className={css.menuItemBorder} />
                  <FormattedMessage id="TopbarDesktop.accountSettingsLink" />
                </NamedLink>
              <div className={css.borderTop} />
                </>
              )
            }
          </MenuItem>*/}
          <MenuItem key="textC">
            {isCustomer && (
              <>
                <p className={css.text}>
                  <FormattedMessage id="TopbarDesktop.customerTitle" />
                </p>
              </>
            )}
          </MenuItem>

          <MenuItem key="AccountSettingsPage">
            {isPractitioner && (
              <>
                <NamedLink className={classNames(css.menuLink)} name="AccountSettingsPage">
                  <span className={css.menuItemBorder} />
                  <FormattedMessage id="TopbarDesktop.LoginSecurityLink" />
                </NamedLink>

                <div
                  style={{ marginTop: '16px', borderBottom: '1px solid var(--colorGrey100)' }}
                ></div>
              </>
            )}
          </MenuItem>

          <MenuItem key="AccountSettingsPage">
            {isCustomer && (
              <NamedLink className={classNames(css.menuLink)} name="PaymentMethodsPage">
                <span className={css.menuItemBorder} />
                <FormattedMessage id="TopbarDesktop.paymentMethodsLink" />
              </NamedLink>
            )}
          </MenuItem>

          <MenuItem key="textP">
            {isPractitioner && (
              <>
                <p className={css.text}>
                  <FormattedMessage id="TopbarDesktop.pracTitle" />
                </p>
              </>
            )}
          </MenuItem>

          <MenuItem key="ProfileSettingsPage">
            {isPractitioner && (
              <>
                <NamedLink className={classNames(css.menuLink)} name="ProfileSettingsPage">
                  <span className={css.menuItemBorder} />
                  <FormattedMessage id="TopbarDesktop.profileSettingsLink" />
                </NamedLink>
              </>
            )}
          </MenuItem>

          <MenuItem key="ProfileSettingsPagecalendar">
            {isPractitioner && (
              <NamedLink
                className={classNames(css.menuLink)}
                name="ProfileSettingsPageTab"
                params={{ tab: 'account' }}
              >
                <span className={css.menuItemBorder} />
                <FormattedMessage id="TopbarDesktop.calendarSyncLink" />
              </NamedLink>
            )}
          </MenuItem>

          <MenuItem key="ProfileSettingsPagePayout">
            {isPractitioner && (
              <NamedLink
                className={classNames(css.menuLink)}
                name="ProfileSettingsPageTab"
                params={{ tab: 'account' }}
              >
                <span className={css.menuItemBorder} />
                <FormattedMessage id="TopbarDesktop.payoutLink" />
              </NamedLink>
            )}
          </MenuItem>

          <MenuItem key="ManageListingsPage">
            {isPractitioner && (
              <NamedLink className={classNames(css.menuLink)} name="ManageListingsPage">
                <span className={css.menuItemBorder} />
                <FormattedMessage id="TopbarDesktop.yourListingsLink2" />
              </NamedLink>
            )}
          </MenuItem>

          <MenuItem key="InboxPage">
            <NamedLink
              className={classNames(css.menuLink)}
              name="InboxPage"
              params={{ tab: inboxTab }}
            >
              <span className={css.menuItemBorder} />
              {isCustomer ? (
                <FormattedMessage id="TopbarDesktop.myServices" />
              ) : (
                <FormattedMessage id="TopbarDesktop.purchasesAndReviews" />
              )}
            </NamedLink>
          </MenuItem>

          <MenuItem key="Inbox">
            {isCustomer && (
              <button type="button" className={classNames(css.menuLink)} onClick={onViewProfile}>
                <span className={css.menuItemBorder} />
                <FormattedMessage id="TopbarDesktop.reviews" />
              </button>
            )}
          </MenuItem>

          <MenuItem key="SearchTribePage">
            {isPractitioner && (
              <NamedLink className={classNames(css.menuLink)} name="SearchTribePage">
                <span className={css.menuItemBorder} />
                <FormattedMessage id="TopbarDesktop.inviteMem" />
              </NamedLink>
            )}
          </MenuItem>

          <MenuItem key="ReferralPage">
            {isPractitioner && (
              <NamedLink
                className={classNames(css.menuLink)}
                name="ProfileSettingsPageTab"
                params={{ tab: 'account' }}
              >
                <span className={css.menuItemBorder} />
                <FormattedMessage id="TopbarDesktop.refAPrac" />
              </NamedLink>
            )}
          </MenuItem>
          <MenuItem key="textCP">
            {isPractitioner && (
              <>
                <div className={css.borderTop} />
                <p className={css.text}>
                  <FormattedMessage id="TopbarDesktop.customerTitle" />
                </p>
              </>
            )}
          </MenuItem>
          <MenuItem key="Inbox">
            {isPractitioner && (
              <>
                <NamedLink
                  className={classNames(css.menuLink)}
                  name="InboxPage"
                  params={{ tab: inboxTab }}
                >
                  <FormattedMessage id="TopbarDesktop.purchasesAndReviews" />
                </NamedLink>
              </>
            )}
          </MenuItem>
          <MenuItem key="AccountSettings">
            {isPractitioner && (
              <>
                <NamedLink className={classNames(css.menuLink)} name="AccountSettingsPage">
                  <FormattedMessage id="TopbarDesktop.paymentMethodsLink" />
                </NamedLink>
              </>
            )}
          </MenuItem>
          <MenuItem key="Care">
            <div className={css.careLink}>
              <a href="mailto:care@munay.live" className={classNames(css.menuLink)}>
                <span className={css.menuItemBorder} />
                <FormattedMessage id="TopbarDesktop.help" />
              </a>
            </div>
          </MenuItem>

          <MenuItem key="logout">
            <InlineTextButton rootClassName={css.logoutButton} onClick={onLogout}>
              <span className={css.menuItemBorder} />
              <FormattedMessage id="TopbarDesktop.logout" />
            </InlineTextButton>
          </MenuItem>
        </MenuContent>
      </Menu>
    );
  };

  /**
   * Topbar for desktop layout
   *
   * @component
   * @param {Object} props
   * @param {string?} props.className add more style rules in addition to components own css.root
   * @param {string?} props.rootClassName overwrite components own css.root
   * @param {boolean} props.currentUserHasListings
   * @param {CurrentUser} props.currentUser API entity
   * @param {string?} props.currentPage
   * @param {boolean} props.isAuthenticated
   * @param {number} props.notificationCount
   * @param {Function} props.onLogout
   * @param {Function} props.onSearchSubmit
   * @param {Object?} props.initialSearchFormValues
   * @param {Object} props.intl
   * @param {Object} props.config
   * @param {boolean} props.showSearchForm
   * @returns {JSX.Element} search icon
   */

  const marketplaceName = config.marketplaceName;
  const authenticatedOnClientSide = mounted && isAuthenticated;
  const isAuthenticatedOrJustHydrated = isAuthenticated || !mounted;

  const giveSpaceForSearch = customLinks == null || customLinks?.length === 0;
  const classes = classNames(rootClassName || css.root, className);

  const inboxLinkMaybe =
    authenticatedOnClientSide && !isCustomer ? (
      <InboxLink
        notificationCount={notificationCount}
        currentUserHasListings={currentUserHasListings}
      />
    ) : null;

  const profileMenuMaybe = authenticatedOnClientSide ? (
    <ProfileMenu currentPage={currentPage} currentUser={currentUser} onLogout={onLogout} />
  ) : null;

  const signupLinkMaybe = isAuthenticatedOrJustHydrated ? null : <SignupLink />;
  const loginLinkMaybe = isAuthenticatedOrJustHydrated ? null : <LoginLink />;

  const searchFormMaybe = showSearchForm ? (
    <TopbarSearchForm
      className={classNames(css.searchLink, { [css.takeAvailableSpace]: giveSpaceForSearch })}
      desktopInputRoot={css.topbarSearchWithLeftPadding}
      onSubmit={onSearchSubmit}
      initialValues={initialSearchFormValues}
      appConfig={config}
    />
  ) : (
    <div
      className={classNames(css.spacer, css.topbarSearchWithLeftPadding, {
        [css.takeAvailableSpace]: giveSpaceForSearch,
      })}
    />
  );

  return (
    <nav className={classes}>
      <LinkedLogo
        className={css.logoLink}
        layout="desktop"
        alt={intl.formatMessage({ id: 'TopbarDesktop.logo' }, { marketplaceName })}
        linkToExternalSite={config?.topbar?.logoLink}
      />
      {searchFormMaybe}
      {!isCustomer && authenticatedOnClientSide && (
        <CustomLinksMenu
          currentPage={currentPage}
          customLinks={customLinks}
          intl={intl}
          hasClientSideContentReady={authenticatedOnClientSide || !isAuthenticatedOrJustHydrated}
        />
      )}

      {inboxLinkMaybe}
      {profileMenuMaybe}
      {signupLinkMaybe}
      {loginLinkMaybe}
    </nav>
  );
};

export default TopbarDesktop;
